<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body text-center pt-5 pb-5">
                        <h1 class="fas fa-exclamation-circle text-danger"></h1>
                        <h3 class="mt-3">{{ $t('verifyEmail.expired') }}</h3>
                        <router-link to="verification-email" class="btn btn-primary btn-sm">{{$t('verifyEmail.emailVerify')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'VerifyEmailExpired'
  };
</script>

<style scoped>

</style>
